import { makeStyles } from 'tss-react/mui';

// For performance reasons we are exporting the styles and passing down via props to avoid
// instantiating per list item. One downside is that we cannot leverage `props` in this instance of
// makeStyles.
const useStyles = makeStyles()(theme => ({
  avatarContainer: {
    marginRight: theme.spacing(1),
  },
  playButtonContainer: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    [theme.breakpoints.only('xs')]: {
      marginLeft: theme.spacing(-5),
      marginRight: theme.spacing(0),
    },
  },
  statusIconContainer: {
    width: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  clipBodyContainer: {
    flexGrow: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    marginLeft: theme.spacing(0.75),
  },
  ctaButtonContainer: {
    marginLeft: '24px',
  },
  ctaButton: {
    minWidth: theme.spacing(12),
  },
  clipBodyTop: {
    display: 'flex',
    alignItems: 'center',
  },
  errorContainer: {
    marginLeft: 'auto',
    textAlign: 'right',
  },
  playbackPositionContainer: {
    flexShrink: 0,
  },
  sliderContainer: {
    marginTop: theme.spacing(-0.5),
  },
  actionsContainer: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(0),
    [theme.breakpoints.only('xs')]: {
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(-2),
    },
  },
  progressBar: {
    borderRadius: 4,
  },
  sliderRoot: {
    // offset the bottom padding for vertical flex alignment
    marginBottom: -10,
    '&:hover .MuiSlider-thumb': {
      opacity: 1,
      visibility: 'visible',
    },
    '@media (pointer: coarse)': {
      padding: `16px 0`,
      marginBottom: -16,
    },
  },
  sliderThumb: {
    '&.MuiSlider-thumb': {
      marginLeft: 0,
    },
    transition: theme.transitions.create(
      ['opacity', 'boxShadow', 'transform'],
      {
        duration: 150,
      }
    ),
    visibility: 'visible',
    boxShadow: `${theme.shadows[1]}`,
    '&:hover': {
      boxShadow: `${theme.shadows[4]}`,
    },
    '&.MuiSlider-active': {
      boxShadow: `${theme.shadows[1]}`,
      transform: `scale(0.85)`,
    },
  },
  // Styles used when user is not dragging the slider to animate the track
  sliderTrackTransition: {
    transition: 'width 250ms ease-in',
  },
  sliderThumbTransition: {
    '&:not(.MuiSlider-active)': {
      transition: 'left 250ms ease-in',
    },
  },
  clipNameFocus: {},

  clipNameText: {
    maxWidth: '30%',
  },
  clipDeselected: {
    // Clip List Note: originally theme.palette.grey[500]
    color: theme.palette.common.white,
    '&:focus': {
      color: theme.palette.common.white,
    },
    '&:focus-within': {
      color: theme.palette.common.white,
    },
    '&:target': {
      color: theme.palette.common.white,
    },
    '&:focus-visible': {
      color: theme.palette.common.white,
    },
  },
  clipSelected: {
    color: theme.palette.common.white,
  },
  clipTextPreviewContainer: {
    maxWidth: '50%',
    flex: 1,
    marginRight: 'auto',
    marginLeft: theme.spacing(1.5),
  },
  clipTextPreview: {
    cursor: 'default',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  highlight: {
    fontSize: '14px',
  },
  lineHeight: {
    lineHeight: 1.2,
  },
  statusIconAndPlayButton: {
    [theme.breakpoints.down('sm')]: {
      padding: '9px',
      zIndex: 1,
      background: `rgba(27, 27, 27, 0.35)`,
      borderRadius: '50%',
    },
  },
  statusIcon: {
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(4),
    },
  },
  avatarCombined: {
    backgroundColor: theme.palette.grey['800'],
    color: theme.palette.text.primary,
  },
  checkbox: {
    // override the default 9px padding for consistency
    // TODO: we should have this be a global MuiCheckbox addition in theme
    padding: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default useStyles;
